export default {"src":"/_next/static/media/upload-white.c6ac6b48.svg","height":192,"width":192};